module.exports = __webpack_public_path__ + "img/hopways.3f407ed1.webp";